import React from 'react';
import { withStyles } from '@material-ui/core';

import { connect } from 'react-redux';

import { Route } from 'react-router-dom';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";

import defaultUserImage from "assets/img/no_profile.png";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import CurrencyText from '../../components/TextHover/CurrencyText';
import { store } from '../../redux/store';
import { SET_PAGE_TITLE } from '../../redux/types';
import Api from '../../api/Api.js';
import ProductEndpoints from '../../api/ProductEndpoints';

import moment from 'moment';
import Loading from '../../components/Loading/Loading';

import PictureUpload from '../../components/CustomUpload/PictureUpload';
import ImageEndpoints from '../../api/ImageEndpoints';
import CustomerList from './CustomerList';
import Pricing from './Pricing';

const styles = {
    account: {

    }
}

class ViewProduct extends React.Component {
    constructor(props) {
        super(props);

        const product_id = props.match.params.product_id ? parseInt(props.match.params.product_id) : 0;
        const customer_id = props.match.params.customer_id ? parseInt(props.match.params.customer_id) : 0;
        const index = props.products.findIndex(x => x.id == product_id);

        store.dispatch({ type: SET_PAGE_TITLE, payload: props.products[index].name })

        this.state = {
            product: props.products[index],
            product_id: product_id,
            gpTwoMonths: null,
            gpLastMonth: null,
            totalGp: null,
            loading: true,
            accounts: [],
            pricing: {},
            customer_id,
            customerSearch: ''
        };
    }

    componentDidMount() {
        Api.get(ProductEndpoints.monthGp, { id: this.state.product_id, relativeMonth: 0 })
            .then(({ data }) => this.setState({ totalGp: data }))
            .catch((e) => console.error(e))
        Api.get(ProductEndpoints.monthGp, { id: this.state.product_id, relativeMonth: -1 })
            .then(({ data }) => this.setState({ gpLastMonth: data }))
            .catch((e) => console.error(e))
        Api.get(ProductEndpoints.monthGp, { id: this.state.product_id, relativeMonth: -2 })
            .then(({ data }) => this.setState({ gpTwoMonths: data }))
            .catch((e) => console.error(e))
        Api.get(ProductEndpoints.customerList, { id: this.state.product_id })
            .then(({ data }) => this.setState({ accounts: data, loading: false }))
            .catch((e) => console.error(e))
    }

    changeProductPicture = (file) => {
        Api.fileUpload(ImageEndpoints.upload, [file], { bind: "product", bind_id: this.state.product_id })
            .then(({ data }) => this.setState({ product: { ...this.state.product, ...data } }))
    }

    retrievePricing() {
        Api.get(ProductEndpoints.pricingForCustomer, { product_id: this.state.product_id, customer_id: this.props.match.params.customer_id })
            .then(({ data }) => this.setState({ pricing: { ...this.state.pricing, [this.props.match.params.customer_id]: data } }))
            .catch((e) => console.error(e))
    }

    refreshCustomerList() {
        Api.get(ProductEndpoints.customerList, { id: this.state.product_id })
            .then(({ data }) => this.setState({ accounts: data, loading: false }))
            .catch((e) => console.error(e))
    }

    render() {
        const { classes } = this.props;
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <Card className={classes.container} profile style={{ textAlign: 'left' }}>
                        <CardAvatar style={{ height: 130, width: 130, position: 'absolute', top: 0, left: 40, zIndex: 1299 }} profile>
                            <PictureUpload
                                style={{ height: 130, width: 130 }}
                                imgStyle={{ height: 122, width: 122 }}
                                preview={this.state.product.image ? ("/api/image/get?id=" + this.state.product.image) : defaultUserImage}
                                onImagePicked={(file) => this.changeProductPicture(file)}
                            />
                        </CardAvatar>
                        <CardBody className={classes.content} profile style={{ paddingTop: 0, marginTop: 0 }}>
                            <div style={{ display: 'flex', width: '100%' }}>
                                <div style={{ width: 200, height: 75 }}>&nbsp;</div>
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                                    <div style={{ flex: 1 }}>
                                        <h3>{this.state.product.name}</h3>
                                        <h5>{this.state.product.description}</h5>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', flexDirection: 'column' }}>
                                        {
                                            this.state.gpTwoMonths ?
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 19 }}>
                                                    {(moment().subtract(2, 'months').format("MMMM"))} GP:&nbsp;&nbsp;&nbsp;<CurrencyText currency="ZAR" value={this.state.gpTwoMonths} style={{ fontSize: 17, color: 'var(--green)' }} icon />
                                                </div>
                                                :
                                                null
                                        }
                                        {
                                            this.state.gpLastMonth ?
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 19 }}>
                                                    {(moment().subtract(1, 'month').format("MMMM"))} GP:&nbsp;&nbsp;&nbsp;<CurrencyText currency="ZAR" value={this.state.gpLastMonth} style={{ fontSize: 17, color: 'var(--green)' }} icon />
                                                </div>
                                                :
                                                null
                                        }
                                        {
                                            this.state.totalGp ?
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 19 }}>
                                                    <strong>{(moment().format("MMMM"))} GP:&nbsp;&nbsp;&nbsp;<CurrencyText currency="ZAR" value={this.state.totalGp} style={{ fontSize: 17, color: 'var(--green)' }} icon /></strong>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: 1, display: 'flex' }}>
                                {
                                    this.state.loading ?
                                        <div style={{ height: 250, flex: 1 }}>
                                            <Loading />
                                        </div>
                                        :
                                        <div style={{ flex: 1, textAlign: 'center' }}>                                            
                                            <Route
                                                exact
                                                path={`/products/view/${this.state.product_id}/${this.props.match.params.customer_id || "0"}`}
                                                component={(props) => {
                                                    if (!this.state.pricing[this.props.match.params.customer_id]) {
                                                        //Fetch it
                                                        this.retrievePricing();
                                                        return (
                                                            <div style={{ height: 250 }}>
                                                                <Loading />
                                                            </div>
                                                        );
                                                    } else {
                                                        return (
                                                            <Pricing
                                                                pricingList={this.state.pricing[this.props.match.params.customer_id]}
                                                                account={this.state.accounts.find(x => x.id == this.props.match.params.customer_id)}
                                                                product_id={this.state.product_id}
                                                                services={this.state.product.services}
                                                                refresh={() => this.retrievePricing()}
                                                            />
                                                        );
                                        }
                                    }}
                                />
                                            <Route
                                                exact
                                                path={`/products/view/${this.state.product_id}`}
                                                component={() => <CustomerList accounts={this.state.accounts} product_id={this.state.product_id} refresh={() => this.refreshCustomerList()} />}
                                            />
                                        </div>
                                }
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state) => ({ products: state.products.list });

export default withStyles({ ...regularFormsStyle, ...extendedFormsStyle, ...styles })(connect(mapStateToProps)(ViewProduct));
